import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Gear = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='m7.99 18.602-.685.158a1.722 1.722 0 0 1-2.065-2.065l.158-.684a1.95 1.95 0 0 0-.817-2.057l-.832-.555a1.682 1.682 0 0 1 0-2.798l.832-.555a1.95 1.95 0 0 0 .817-2.057l-.158-.684A1.722 1.722 0 0 1 7.305 5.24l.684.158a1.95 1.95 0 0 0 2.057-.817l.555-.832a1.682 1.682 0 0 1 2.798 0l.555.832a1.95 1.95 0 0 0 2.057.817l.684-.158a1.722 1.722 0 0 1 2.065 2.065l-.158.684a1.95 1.95 0 0 0 .817 2.057l.832.555a1.682 1.682 0 0 1 0 2.798l-.832.555a1.95 1.95 0 0 0-.817 2.057l.158.684a1.722 1.722 0 0 1-2.065 2.065l-.684-.158a1.95 1.95 0 0 0-2.057.817l-.555.832a1.682 1.682 0 0 1-2.798 0l-.555-.832a1.95 1.95 0 0 0-2.057-.817'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.977 20.667a2.432 2.432 0 0 0 4.046 0l.555-.832c.276-.414.78-.614 1.264-.502l.684.158a2.472 2.472 0 0 0 2.965-2.965l-.158-.684a1.2 1.2 0 0 1 .502-1.264l.832-.555a2.432 2.432 0 0 0 0-4.046l-.832-.555a1.2 1.2 0 0 1-.502-1.264l.158-.684a2.472 2.472 0 0 0-2.965-2.965l-.684.158a1.2 1.2 0 0 1-1.264-.502l-.555-.832a2.432 2.432 0 0 0-4.046 0l-.555.832c-.276.414-.78.614-1.264.502l-.684-.158a2.472 2.472 0 0 0-2.965 2.965l.158.684c.112.485-.088.988-.502 1.264l-.832.555a2.432 2.432 0 0 0 0 4.046l.832.555c.414.276.614.78.502 1.264l-.158.684a2.472 2.472 0 0 0 2.965 2.965l.684-.158c.485-.112.988.088 1.264.502zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6'
        fill='currentColor'
      />
    )}
  </IconBase>
);
